const PaymentMethodDetailsTypes = {
    "web": "web",
    "mobile-app": "mobile-app"
};
var payment_method_details = Object.freeze(PaymentMethodDetailsTypes);

export { payment_method_details as default };
//# sourceMappingURL=payment_method_details.js.map
